import { useQuery } from "@tanstack/react-query"
import {
  getReportRoutingLogs,
  getDistinctPatientIssuers,
  getReportRoutingLogById,
} from "../api/reportRoutingLogs"

export const useReportRoutingLogs = (params = {}) =>
  useQuery({
    queryKey: ["reportRoutingLogs", params],
    queryFn: () => getReportRoutingLogs(params),
    keepPreviousData: true,
    select: (data) => data?.data || [],
  })

export const useDistinctPatientIssuers = () =>
  useQuery({
    queryKey: ["distinctPatientIssuers"],
    queryFn: getDistinctPatientIssuers,
    select: (data) => data?.data?.patientIssuers || [],
  })

export const useReportRoutingLogById = (logId) =>
  useQuery({
    queryKey: ["reportRoutingLog", logId],
    queryFn: () => getReportRoutingLogById(logId),
    enabled: !!logId,
    select: (data) => data?.data || {},
  })
